import { cva } from 'class-variance-authority'

export const emptyStateContentVariants = cva(
  'mx-auto flex w-full max-w-md flex-col items-center space-y-2 text-center',
  {
    variants: {
      size: {
        compact: 'p-4',
        default: 'p-8',
        page: 'p-8',
      },
    },
  },
)

export const emptyStateHeadingVariants = cva(
  'w-full text-balance break-words text-center font-medium text-primary',
  {
    variants: {
      size: {
        compact: 'text-sm',
        default: 'text-lg',
        page: 'text-4xl',
      },
    },
  },
)

export const emptyStateBodyVariants = cva('', {
  variants: {
    textSize: {
      xs: 'text-xs',
      sm: 'text-sm',
      inherit: '',
    },
  },
  defaultVariants: {
    textSize: 'inherit',
  },
})
